module.exports = __webpack_public_path__ + "2f2cf4ad9d6660204b689cf2f0b55cab.fbx";